export const PATIENT_PORTAL_ROUTE = '/patient_portal';
export const NOTIFICATION_PREFERENCES_ROUTE = '/notification_preferences';
export const FEATURE_FLAGS_ROUTE = '/flags';
